import React, { Component } from 'react';

const promiseFactory = imports => {
    const promises = [];

    for (let moduleId in imports) {
        if (imports.hasOwnProperty(moduleId)) {

            let promiseWrapper = new Promise(resolve => {
                imports[moduleId].then(function (module) {
                    resolve({ [moduleId]: module });
                });
            });

            promises.push(promiseWrapper);
        }
    }

    return promises;
};

export default function dynamicImport(WrappedComponent, imports) {

    return class extends Component {

        constructor(props) {
            super(props);
            this.state = {
                modules: null
            };
        }

        componentDidMount() {
            Promise.all(promiseFactory(imports))
                .then(modules => {
                    this.setState({ modules: Object.assign(...modules) })
                })
        }

        render() {
            if (!this.state.modules) {
                return null;
            }

            return <WrappedComponent {...this.props} modules={this.state.modules} />
        }

    }

};


// WEBPACK FOOTER //
// ./web/src/components/common/dynamicImport.jsx